import React from 'react'

type Toast = { id: string; text: string }

const ToastCtx = React.createContext<{ push: (text: string) => void } | null>(null)

export function ToastProvider({ children }: { children: React.ReactNode }) {
  const [toasts, setToasts] = React.useState<Toast[]>([])
  const lastByTextRef = React.useRef<Map<string, number>>(new Map())
  const push = (text: string) => {
    const now = Date.now()
    const last = lastByTextRef.current.get(text) || 0
    // Deduplicate identical toasts within 4 seconds
    if (now - last < 4000) return
    lastByTextRef.current.set(text, now)
    const id = Math.random().toString(36).slice(2)
    setToasts(t => [...t, { id, text }])
    setTimeout(() => setToasts(t => t.filter(x => x.id !== id)), 3000)
  }
  return (
    <ToastCtx.Provider value={{ push }}>
      {children}
      <div style={{ position: 'fixed', right: 12, top: 12, zIndex: 100, display: 'grid', gap: 8 }} aria-live="polite">
        {toasts.map(t => (
          <div key={t.id} style={{ background: 'var(--panel)', color: 'var(--text)', padding: '10px 12px', borderRadius: 10, boxShadow: '0 8px 24px rgba(0,0,0,0.35)' }}>
            {t.text}
          </div>
        ))}
      </div>
    </ToastCtx.Provider>
  )
}

export function useToast() {
  const ctx = React.useContext(ToastCtx)
  if (!ctx) throw new Error('useToast must be used within ToastProvider')
  return ctx
}
